export function PepettesLogo() {
  return (
    <span className="mb-6 flex items-center gap-2 text-2xl font-semibold text-gray-900">
      <img className="h-8 w-8" src="./favicon.svg" alt="Pepettes logo" />{" "}
      Pepettes
    </span>
  );
}
